module.exports = __webpack_public_path__ + "static/Corprate_Careers_08-1bdbc51bbb595fdb081279faa88bb299.jpg";